<template>
  <button
    class="action-button"
    :style="
      buttonType == 'positive'
        ? {
            color: this.guestBookForm.textColor,
            'background-color': this.guestBookForm.formColor,
          }
        : {
            color: '#AAAAAA',
            border: 'solid 2px #AAAAAA',
            'background-color': 'transparent',
          }
    "
    :disabled="disabled"
    @click="$emit('emitEvent')"
  >
    {{ buttonText.toUpperCase() }}
  </button>
</template>

<script>
export default {
  props: {
    buttonText: String,
    buttonType: String,
    disabled: Boolean,
    guestBookForm: Object,
  },
};
</script>

<style scoped>
.action-button {
  width: 130px;
  height: 50px;
  padding: 0 15px;
  border: none;
  border-radius: 10px;

  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
}
.action-button:hover {
  cursor: pointer;
}
.action-button:disabled {
  opacity: 0.5;
}
.action-button:disabled:hover {
  cursor: not-allowed;
}

@media (max-width: 350px) {
  .action-button {
    width: 95px;
    height: 45px;
    line-height: 20px;
    font-size: 12px;
  }
}
</style>
